import {
    GET_CONFIG_FORM,
    GET_CRITERIOS_FECHA,
    GET_ESTADOS_CASO,
    GET_INSTANCIA_JUDICIAL,
    GET_TAREAS,
    GET_COMPANIAS,
    GET_TAREAS_USUARIO,
    GET_CASOS_BANDEJA,
    GET_XLS_CASOS_BANDEJA,
    GET_RANGO_FECHAS,
    CLEAR_CASOS_BANDEJA,
    GET_FILTROS,
    GET_SIT_PENDIENTE,
    GET_XLS_CASOS_BANDEJA_INTER_CIAS
} from '../types';


export default function recuperoCiasReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM:
            return { ...state, ...action.payload }
        case GET_TAREAS:
            return { ...state, tareas: action.payload }
        case GET_ESTADOS_CASO:
            return { ...state, estadocaso: action.payload }
        case GET_COMPANIAS:
            return { ...state, companias: action.payload }
        case GET_INSTANCIA_JUDICIAL:
            return { ...state, intanciajudicial: action.payload }
        case GET_CRITERIOS_FECHA:
            return { ...state, criteriofecha: action.payload }
        case GET_TAREAS_USUARIO:
            return { ...state, tareasusuario: action.payload }
        case GET_CASOS_BANDEJA:
            return { ...state, bandeja: action.payload }
        case CLEAR_CASOS_BANDEJA:
            return { ...state, bandeja: action.payload }
        case GET_XLS_CASOS_BANDEJA:
            return { ...state, xlscasosbandeja: action.payload }
        case GET_RANGO_FECHAS:
            return { ...state, rangofechas: action.payload }
        case GET_FILTROS:
            return { ...state, filtros: action.payload }
        case GET_SIT_PENDIENTE: 
            return { ...state, situacionPendientes: action.payload }
        case GET_XLS_CASOS_BANDEJA_INTER_CIAS:
            return { ...state, xlscasosbandejaintercias: action.payload }
        default:
            return state
    }
}